import * as actionTypes from '../../../constants/ActionTypes/CSAgentPortal/CustomerDashboard';

const initialState = {
    subscriptionInfo: {},
    loading: false,
    error: null,
    success: false
}

const SubscriptionDetails = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_SUBSCRIPTION_DETAILS_INIT:
            return {
                ...state,
                loading: true
            }
        
        case actionTypes.FETCH_SUBSCRIPTION_DETAILS_SUCCESS:
            return {
                ...state,
                subscriptionInfo: action.subscriptionInfo,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.FETCH_SUBSCRIPTION_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                subscriptionInfo: {},
                success: false
            }
        case actionTypes.RESET_SUBSCRIPTION_DETAILS_ERROR:
            return { ...state, 
                loading: false,
                error:null,
                subscriptionInfo: {},
                success: false
              };
        default:
            return {...state}
    }
}

export default SubscriptionDetails;